import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LeadNewness } from '../api/models';
import { State } from '../store/interfaces';
import {
  loadNewnessErrorAction,
  loadNewnessRequestAction,
  loadNewnessSuccessAction,
} from '../store/reducers/leadNewness';
import { StatusCodes } from 'http-status-codes';
import { LeadNewnessService } from '../api';

export const useLeadNewness = (leadNewnessService: LeadNewnessService) => {
  const intent = useSelector((state: State) => state.leadNewness);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadLeadNewness = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadNewnessRequestAction());
    try {
      const response = await leadNewnessService.loadAllLeadNewness();

      return dispatch(loadNewnessSuccessAction(response));
    } catch (error) {
      return dispatch(loadNewnessErrorAction());
    }
  };

  const updateLeadNewness = async (
    data: LeadNewness,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await leadNewnessService.updateLeadNewness(data, id);
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError('Unable to update details');
      }
    } catch (error) {
      setUpdateError('Unable to update details');
    }
    setUpdating(false);
  };

  return {
    loadLeadNewness,
    updateLeadNewness,
    updating,
    updateError,
  };
};
